import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { MarketComparisonEffects } from './market-comparison.effects';
import { reducer } from './market-comparison.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('marketComparison', reducer),
    EffectsModule.forFeature([MarketComparisonEffects]),
  ],
  providers: [MarketComparisonEffects],
})
export class MarketComparisonStoreModule {}
